import zIndex from "@mui/material/styles/zIndex";
import { useToastContext } from "components/alert/ToastContext";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import RejeitarViagemRequest from "model/viagem/RejeitarViagemRequest";
import Viagem from "model/viagem/Viagem";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog"
import { InputTextarea } from "primereact/inputtextarea";
import { ScrollPanel } from "primereact/scrollpanel"
import { useLoadingContext } from "provider/LoadingProvider";
import { useState } from "react";
import Lightbox from "react-image-lightbox";
import ViagemAprovacaoService from "service/viagem/ViagemAprovacaoService";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    viagem: Viagem | null;
}

const viagemAprovacaoService = new ViagemAprovacaoService();
export default function ModalRejeitarViagem(props: Props) {

    const [motivo, setMotivo] = useState<string>('');
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro } = useToastContext();

    const rejeitarViagem = (viagem: Viagem) => {
        startLoading();
        viagemAprovacaoService.rejeitar(new RejeitarViagemRequest(viagem.id, motivo)).then((v) => {
            msgSucesso('Viagem', 'Viagem rejeitada');
            props.onConfirm();
        }).catch(e => {
            msgErro('Viagem', e.data.message);
        }).finally(() => {
            stopLoading()
        });
    };
    return (
        <>
            <Dialog 
                header="Rejeitar viagem" 
                visible={props.visible} 
                baseZIndex={500} 
                style={{ width: '50vw' }} 
                onHide={() => props.onHide()}
                footer={<>
                    <Button label="Cancelar" onClick={() => props.onHide()} />
                    <Button label="Rejeitar" className="p-button-danger" onClick={() => {
                        console.log(props.viagem)
                        if (props.viagem) {
                            rejeitarViagem(props.viagem);
                        }
                    }} disabled={motivo.trim().length === 0} />
                </>}
                >
                <div>
                    <InputTextarea
                        rows={5} cols={30} autoResize placeholder="Motivo da rejeição" style={{ width: '100%' }}
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                    />
                </div>

            </Dialog>
        </>
    )
}